import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';
import { AnswerIconO, AnswerIconX } from '@/shared/components/AnswerIcon';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizOXChoice - O/X 선택 컴포넌트
 * OXContent 구조와 일치하는 읽기 전용 버전
 * @module QuizOXChoice
 */

type OXAnswer = 'o' | 'x';
interface ContainerProps extends ComponentPropsWithoutRef<'div'> {
  answer: OXAnswer;
}

/**
 * O/X 선택 표시를 위한 컨테이너
 * LmsO/LmsX 아이콘이 있는 OXContent 구조와 일치
 */
const Container = memo(forwardRef<HTMLDivElement, ContainerProps>(({
  answer,
  className,
  ...rest
}, ref) => {
  return <div ref={ref} className={cn('flex w-full', className)} {...rest}>
          <div className="relative w-fit rounded-sm border border-alternative bg-white p-md">
            {answer === 'o' ? <AnswerIconO className="size-[40px]" /> : <AnswerIconX className="size-[40px]" />}
          </div>
        </div>;
}));
Container.displayName = 'QuizOXChoiceContainer';
export const QuizOXChoice = {
  Container
};